// import { useMutation } from "@tanstack/react-query";
// import { generateUrlParamsFromObject } from "./generateUrlParamsFromObject";
// import { useHttp } from "./useHttp";
// import showToast from "../components/Hot-Toast/showToast";
// import { useState } from "react";

// export function useTMutation(url, method = "post", callback, pathParams, appendQueryParams) {
//   const api = useHttp();
//   const [errorStack, setErrorStack] = useState(null);
//   return useMutation({
//     mutationFn: async (requestBody) => {
//       try {
//         // Ensure method is valid
//         if (!api[method]) {
//           throw new Error(`HTTP method ${method} is not supported`);
//         }

//         if (pathParams) {
//           return await api[method](
//             `${url}/${generateUrlParamsFromObject({ data: requestBody, acceptedPathParams: pathParams })}`
//           ).then((res) => res.data);
//         }

//         if (appendQueryParams) {
//           return await api[method](
//             `${url}${generateUrlParamsFromObject({ data: requestBody })}`
//           ).then((res) => res.data);
//         }

//         if (method === "delete") {
//           return await api.delete(`${url}`, { data: requestBody }).then((res) => res?.data);
//         }

//         return await api[method](`${url}`, requestBody).then((res) => res?.data);
//       } catch (error) {
//         // Handle errors gracefully
//         console.error("Request Error:", error);
//         setErrorStack(error.stack);
//         throw error; // Ensure that `react-query` can handle it
//       }
//     },
//     onError: (error) => {
//       const statusCode = error?.response?.status;
//       const errorDetail = error?.response?.data?.error || "An unknown error occurred";
//       const stackTrace = error?.stack || "No stack trace available";
//       console.log("stackTrace", stackTrace)
//       setErrorStack(stackTrace); // Update state with error stack
//       // Provide user-friendly error messages based on the status code
//       if (statusCode === 401) {
//         showToast('error', "Unauthorized request, please login again", 3000);
//       } else if (statusCode === 403) {
//         showToast('error', "You don't have permission to access this resource", 3000);
//       } else if (statusCode === 404) {
//         showToast('error', "Resource not found", 3000);
//         return;
//       } else if (statusCode >= 500) {
//         showToast('error', "Server error, please try again later!", 3000);
//       } else {
//         console.log(errorDetail);
//       }
//     },
//     onSuccess: (response) => {
//       callback(response);
//     },
//   });
// }

// useTMutation.js
import { useMutation } from "@tanstack/react-query";
import { generateUrlParamsFromObject } from "./generateUrlParamsFromObject";
import { useHttp } from "./useHttp";
import showToast from "../components/Hot-Toast/showToast";
import { useState } from "react";

export function useTMutation(url, method = "post", callback = () => {}, pathParams, appendQueryParams) {
  const api = useHttp();
  const [errorStack, setErrorStack] = useState(null);
  return useMutation({
    mutationFn: async (requestBody) => {
      try {
        if (!api[method]) {
          throw new Error(`HTTP method ${method} is not supported`);
        }

        if (pathParams) {
          return await api[method](
            `${url}/${generateUrlParamsFromObject({ data: requestBody, acceptedPathParams: pathParams })}`
          ).then((res) => res.data);
        }

        if (appendQueryParams) {
          return await api[method](
            `${url}${generateUrlParamsFromObject({ data: requestBody })}`
          ).then((res) => res.data);
        }

        if (method === "delete") {
          return await api.delete(`${url}`, { data: requestBody }).then((res) => res?.data);
        }

        return await api[method](`${url}`, requestBody).then((res) => res?.data);
      } catch (error) {
        console.error("Request Error:", error);
        setErrorStack(error.stack);
        throw error;
      }
    },
    onError: (error) => {
      const statusCode = error?.response?.status;
      const errorDetail = error?.response?.data?.error || "An unknown error occurred";
      const stackTrace = error?.stack || "No stack trace available";
      console.log("stackTrace", stackTrace);
      setErrorStack(stackTrace);
      
      if (statusCode === 401) {
        showToast('error', "Unauthorized request, please login again", 3000);
      } else if (statusCode === 403) {
        showToast('error', "You don't have permission to access this resource", 3000);
      } else if (statusCode === 404) {
        showToast('error', "Resource not found", 3000);
        return;
      } else if (statusCode >= 500) {
        showToast('error', "Server error, please try again later!", 3000);
      } else {
        console.log(errorDetail);
      }
    },
    onSuccess: (response) => {
      callback(response);
    },
  });
}